module.exports = __webpack_public_path__ + "29a1c6ccbbabc192dbb4634dca544451.fbx";